import React, { useEffect, useState } from 'react';
import Header from './Header';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';


function Waitlist() {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    willingToUse: false,
  });

  const [isWillingToUseYes, setWillingToUseYes] = useState(false);
  const [isWillingToUseNo, setWillingToUseNo] = useState(false);

  const handleYesChange = () => {
    setFormData({
      ...formData,
      willingToUse: true,
    });
    setWillingToUseYes(!isWillingToUseYes);
    setWillingToUseNo(false);
  };

  const handleNoChange = () => {
    setFormData({
      ...formData,
      willingToUse: false,
    });
    setWillingToUseNo(!isWillingToUseNo);
    setWillingToUseYes(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.name.trim() === '' || formData.email.trim() === '') {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please fill out all fields.',
      });
      return; // Stop the execution of the function
    }
  
    console.log('Name:', formData.name);
    console.log('Email:', formData.email);
  

    console.log('Name:', formData.name);
    console.log('Email:', formData.email);

    try {
      await axios.post('http://localhost:5000/register', {
        name: formData.name,
        email: formData.email,
        willingToUse: formData.willingToUse ? 'Yes' : 'No',
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      // Display success alert using SweetAlert
      Swal.fire({
        icon: 'success',
        title: 'Form Submitted Successfully!',
        text: 'Thank you for joining the waitlist!',
      });

      
      // Clear input fields after successful submission
      setFormData({
        name: '',
        email: '',
        willingToUse: false,
      });


      // Add any additional logic or redirect here
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Display error alert for duplicate email
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.error,
        });


                // Clear input fields after displaying error
                setFormData({
                  ...formData,
                  name:'',
                  email: '',
                });
      } else {
        // Display generic error alert
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Error submitting form. Please try again.',
        });
      }
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <section id="support" className="scroll-mt-17">
        <div className="max-w-[1104px] mx-auto px-4 sm:px-8 xl:px-0">
          <div className="relative z-999 overflow-hidden rounded-[30px] bg-dark pt-25 px-4 sm:px-20 lg:px-27.5">
            {/* grid row */}
            <div className="flex justify-center gap-7.5 absolute left-1/2 -translate-x-1/2 -top-[16%] max-w-[690px] w-full -z-1 opacity-40">
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-12">
              </div>
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-7">
              </div>
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-3">
              </div>
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border">
              </div>
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border">
              </div>
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border">
              </div>
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-2">
              </div>
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-5">
              </div>
              <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-8">
              </div>
            </div>
            {/* stars */}
            <div className="max-w-[482px] w-full h-60 overflow-hidden absolute -z-1 -top-30 left-1/2 -translate-x-1/2">
              <div className="stars" />
              <div className="stars2" />
            </div>
            {/* bg shapes */}
            <div className="absolute -z-10 pointer-events-none inset-0 overflow-hidden">
              <span className="absolute left-1/2 top-0 -translate-x-1/2 -z-1">
                <img src={require('../images/blur/blur-19.svg').default} alt="blur" className="max-w-none" />
              </span>
              <span className="absolute left-1/2 top-0 -translate-x-1/2 -z-1">
                <img src={require('../images/blur/blur-20.svg').default} alt="blur" className="max-w-none" />
              </span>
              <span className="absolute left-1/2 top-0 -translate-x-1/2 -z-1">
                <img src={require('../images/blur/blur-21.svg').default} alt="blur" className="max-w-none" />
              </span>
            </div>
            {/* section title */}
            <div className="wow fadeInUp mb-16 text-center relative z-999">
              <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                <img src={require('../images/hero/icon-title.svg').default} alt="icon" />
                <span className="hero-subtitle-text"> Want an early access? </span>
              </span>
              <h2 className="text-white mb-4.5 text-2xl  sm:text-4xl xl:text-heading-2 font-bold">
                Join Waitlist 🚀
              </h2> 
              <p className="max-w-[700px] mx-auto mb-1 font-medium md:text-lg text-white">

                Be one of the first to access the full power of Intellevo by joining the waitlist now.
              </p>
            </div>
            {/* support form */}
            <div className="form-box-gradient relative overflow-hidden rounded-[25px] bg-dark p-6 sm:p-8 xl:p-15">
              <form className="relative z-10" onSubmit={handleSubmit}>
                <div className="-mx-4 xl:-mx-10 flex flex-wrap">
                  <div className="w-full px-4 xl:px-5 md:w-1/2">
                    <div className="mb-9.5">
                      <label htmlFor="name" className="text-white mb-2.5 block font-medium">
                        Name
                      </label>
                      <input 
                      id="name" 
                      type="text" 
                      name="name" 
                      placeholder="Enter your name" 
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                       className="rounded-lg border border-white/[0.12] bg-white/[0.05] focus:border-purple w-full py-3 px-6 outline-none" />
                    </div>
                  </div>
                  <div className="w-full px-4 xl:px-5 md:w-1/2">
                    <div className="mb-9.5">
                      <label htmlFor="email" className="text-white mb-2.5 block font-medium">
                        Email
                      </label>
                      <input id="email" 
                      type="email" 
                      name="email" 
                      value={formData.email}
                      placeholder="Enter your email" 
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="rounded-lg border border-white/[0.12] bg-white/[0.05] focus:border-purple w-full py-3 px-6 outline-none" />
                    </div>
                  </div>
                  <div className="w-full px-4 xl:px-5">
                    <div className="mb-10">

                      {/* <div className="flex items-center mb-4">
                        <input
                          type="checkbox"
                          id="willingToUseYes"
                          name="willingToUse"
                          className="mr-2"
                          checked={isWillingToUseYes}
                          onChange={handleYesChange}
                        />
                      </div> */}

                      {/* <div className="flex items-center mb-4">
                        <input
                          type="checkbox"
                          id="willingToUseNo"
                          name="willingToUse"
                          className="mr-2"
                          checked={isWillingToUseNo}
                          onChange={handleNoChange}
                        />

                      </div> */}
                    </div>
                  </div>
                  <div className="w-full px-4 xl:px-5">
                    <div className="text-center">
                    <button href="#" className="hero-button-gradient inline-flex rounded-lg py-3 px-7 text-white font-medium ease-in duration-300 hover:opacity-80">
                          Join Now
                    </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* what u waiting for section */}
      <section>
        <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
          <div className="cta-box-gradient bg-dark rounded-[30px] relative overflow-hidden px-4 py-20 lg:py-25 z-999">
            {/* bg shapes */}
            <span className="absolute bottom-0 left-0 -z-1"><img src={require('../images/cta/grid.svg').default} alt="grid" /></span>
            <div className="absolute -z-10 pointer-events-none inset-0 overflow-hidden">
              <span className="absolute left-1/2 bottom-0 -translate-x-1/2 -z-1">
                <img src={require('../images/blur/blur-22.svg').default} alt="blur" className="max-w-none" />
              </span>
              <span className="absolute left-1/2 bottom-0 -translate-x-1/2 -z-1">
                <img src={require('../images/blur/blur-23.svg').default} alt="blur" className="max-w-none" />
              </span>
              <span className="absolute left-1/2 bottom-0 -translate-x-1/2 -z-1">
                <img src={require('../images/blur/blur-24.svg').default} alt="blur" className="max-w-none" />
              </span>
            </div>
            {/* stars */}
            <div className="max-w-[482px] w-full h-60 overflow-hidden absolute -z-1 -bottom-25 left-1/2 -translate-x-1/2">
              <div className="stars" />
              <div className="stars2" />
            </div>
            <div className="wow fadeInUp text-center">
              <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                <img src={require('../images/hero/icon-title.svg').default} alt="icon" />
                <span className="hero-subtitle-text">
                  Try our tool for Free
                </span>
              </span>
              <h2 className="text-white mb-4.5 text-2xl font-bold sm:text-4xl xl:text-heading-2">
                What are you waiting for?
              </h2>
              <p className="max-w-[714px] mx-auto font-medium mb-9 text-white">
                Experience the power of our tool for free. Dive into effortless
                and innovative diagram creation today!
              </p>
              <a href="#" className="hero-button-gradient inline-flex rounded-lg py-3 px-7 text-white font-medium ease-in duration-300 hover:opacity-80">
                <Link to="/waitlist">Get Started for Free 🚀</Link>
              </a>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default Waitlist